import {format} from 'date-fns/format'
import {parseISO} from 'date-fns/parseISO'
import {de} from 'date-fns/locale/de'
// @ts-ignore
import {formatInTimeZone} from 'date-fns-tz'

export const useDates = () => {

    const formatDate = (date: Date | string, formatString: string): string => {
        if (typeof date === 'string') {
            date = parseISO(date)
        }
        return format(date, formatString, {locale: de})
    }

    const formatShortDate = (date: Date | string): string => {
        if (typeof date === 'string') {
            date = parseISO(date)
        }
        return format(date, 'EEEEEE, dd.MM.', {locale: de})
    }

    const toIsoString = (date: Date | string): string => {
        if (typeof date === 'string') {
            date = parseISO(date)
        }

        return format(date, "yyyy-MM-dd'T'HH:mm:ss", {locale: de}) + formatInTimeZone(new Date(), 'Europe/Berlin', "XXXXX")
    }

    const formatDateToIso = (date) => {
        return format(date, 'yyyy-MM-dd')
    }

    return {
        formatDate,
        formatShortDate,
        toIsoString,
        formatDateToIso,
    }
}


